



































import {Component, Prop, Vue} from "vue-property-decorator";
import CarInfoInput from "@/component/mypage/car-info-input.vue";
import {CarInfoInputModel} from "@/model/car-info/car-info-input.model";
import {CarInfoInputChecker} from "@/model/car-info/functions/car-info-input-checker";
import axios from "axios";
import {AxiosUtils} from "@/axios-utils";
import {CarInfoModel} from '@/model/car-info/car-info.model';

@Component({
    components: {CarInfoInput}
})
export default class CarInfoEdit extends Vue {
    @Prop() private model: CarInfoInputModel;
    @Prop() private isRegister: boolean;

    isUpdated: boolean = false;

    /** 画面の非表示 */
    close() {
        // ダイアログをクローズする
        this.$emit('close', null);
    }

    submitCarInfo() {
        this.isUpdated = true;
        // お車情報の入力チェック
        const hasErrorCar: boolean = !CarInfoInputChecker.checkAll(this.model);
        // 入力エラーがある場合は、スクロールを上部に戻し、処理を終了
        if (hasErrorCar) {
          if(CarInfoInputChecker.checkHaveErrorAtMakerCarTypeFreeInputTireSize(this.model)){
            // メーカー、車種、装着タイヤサイズのプルダウンでエラーがある場合
            const elem = document.getElementById("carInfoDialogBody");
            elem.scrollTop = 0;
          } else {
            // 車両番号でエラーがある場合
            // 画面設計書では車両番号へのスクロールについて記述があるが、登録/更新ボタンを押下する際は、画面は車両番号の位置となっているため、スクロール処理は実装しない
          }
          this.isUpdated = false;
        }
        // エラーが無ければ次の画面に進む
        else {
            // 送信するデータを作成する
            // ※ CarInfoInputModel（this.model）にはマスタデータ等、送信に不要なデータがあるためCarInfoModelにコピー
            //    Object.assignだと不要なプロパティまでコピーされるので使用しない
            // ※ this.modelを直接編集すると、サーバサイド処理前に画面にタイヤサイズのデータ設定が反映されてしまう問題もある
            const sendData = new CarInfoModel();
            sendData.copy(this.model);

            // 前後で異なるサイズのタイヤを利用しているフラグがない場合、前タイヤサイズの値と同じ値を後タイヤに設定
            if (!this.model.showBothTireFlag) {
                sendData.syncFront();
            }

            // 前後タイヤの各種値をセットする
            sendData.setFrontTireValue(this.model.tireMaster.frontTireSizeList, this.model.carTypeMaster.carTypeDetails);
            sendData.setReaTireValue(this.model.tireMaster.reaTireSizeList, this.model.carTypeMaster.carTypeDetails);

            if (this.model.id) {
                // 更新
                const myCarId = this.model.id
                axios.patch(`/carinfo/${myCarId}`, sendData)
                    // 成功の場合、完了画面に遷移
                    .then(() => {
                        // APIで更新したデータと同期をとる
                        this.model.copy(sendData as CarInfoInputModel);
                        // 更新日を更新
                        this.model.setLastModifiedDatetimeNow();
                        // ダイアログをクローズする
                        this.$emit('close', true);
                    })
                    // エラーの場合
                    .catch(error => AxiosUtils.gotoClientErrorPage(error, this.$router));
            } else {
                // 登録
                axios.post("/carinfo", sendData)
                    // 成功の場合、完了画面に遷移
                    .then((response) => {
                        // APIで登録したデータと同期をとる
                        this.model.copy(sendData as CarInfoInputModel);
                        this.model.id = response.data.id;
                        this.model.isFirst = response.data.isFirst;
                        // 更新日を更新
                        this.model.setLastModifiedDatetimeNow();
                        // ダイアログをクローズする
                        this.$emit('close', true);
                    })
                    // エラーの場合
                    .catch(error => AxiosUtils.gotoClientErrorPage(error, this.$router));
            }
        }
    }
}
